// @flow

import { ThemeProvider, css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import * as React from 'react'

import * as lib from '@toggl/cookie-warning/src/lib'
import { colors, media, themes } from '@toggl/style'
import { Button, text, useHasMounted } from '@toggl/ui'

export const CookieWarning = () => {
  const [exists, setExists] = React.useState(false)
  const hasMounted = useHasMounted()

  const setCookie = React.useCallback(() => {
    lib.setCookie()
    setExists(true)
  }, [setExists])

  React.useLayoutEffect(() => {
    if (!hasMounted) {
      return
    }

    if (lib.cookieExists()) {
      setExists(true)
    }
  }, [hasMounted, setExists])

  if (!hasMounted || exists) {
    return null
  }

  return (
    <CookieWarningRoot>
      <P>
        We use cookies to ensure you get the best experience on our site.&nbsp;
        <LinkStyled to="/legal/">
          <Strong>More details</Strong>
        </LinkStyled>
        .
      </P>
      <ThemeProvider theme={themes.track}>
        <Button.Primary
          css={css`
            justify-content: center;

            ${media.mq[1]} {
              height: 44px;
            }
          `}
          fluid
          onClick={setCookie}
        >
          Got it
        </Button.Primary>
      </ThemeProvider>
    </CookieWarningRoot>
  )
}

const CookieWarningRoot = styled<{ children: React.Node }>('div')`
  ${text.paragraph4};
  color: ${colors.darkPurple};
  background: ${colors.almostWhite};
  bottom: 0;
  padding: 1.2rem;
  position: fixed;
  right: 0;
  width: 100%;

  /* FIXME: Have to set this high because of weird z-index values, e.g. in the footer and stuff. */
  z-index: 9999999;

  ${media.mq[1]} {
    max-width: 20rem;
    bottom: 1rem;
    right: 1rem;
  }

  @media print {
    display: none;
  }
`

const LinkStyled = styled(Link)`
  color: ${colors.darkPurple};
  text-decoration: underline;
`

// TODO: Please replace me with something in `@toggl/ui`.
const P = styled.p`
  color: ${colors.darkPurple};
  line-height: 1.4;
  margin-bottom: 0.8rem;
`

const Strong = styled.span`
  font-weight: 600;
`
